const API = {
  development: {
    agendamento:
      'https://api-dev.rededor.com.br/area-paciente/v1/agendamento-consulta',
    areaDoPaciente: 'https://api-dev.rededor.com.br/area-paciente/v1'
  },
  homolog: {
    agendamento:
      'https://api-hml.rededor.com.br/area-paciente/v1/agendamento-consulta',
    areaDoPaciente: 'https://api-hml.rededor.com.br/area-paciente/v1'
  },
  test: {
    agendamento:
      'https://api-dev.rededor.com.br/area-paciente/v1/agendamento-consulta',
    areaDoPaciente: 'https://api-dev.rededor.com.br/area-paciente/v1'
  },
  production: {
    agendamento:
      'https://api.rededor.com.br/area-paciente/v1/agendamento-consulta',
    areaDoPaciente: 'https://api.rededor.com.br/area-paciente/v1'
  }
}

export default API[process.env.REACT_APP_NODE_ENV]
